import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import styled from 'styled-components';

import ArrowRight from '@upright/ui/icons/img/streamline-mini-line/interface-essential/arrows/interface-arrows-right.svg';
import ArrowLeft from '@upright/ui/icons/img/streamline-mini-line/interface-essential/arrows/interface-arrows-left.svg';
import { useCarouselLayout } from '../context';

export function NegativePositiveTitles() {
  const layout = useCarouselLayout();
  const titlesArea = layout.topTitlesArea();
  const centerArea = layout.centerArea();
  const margin = 10;
  const imageSize = 14;
  return (
    <g className="neg-pos-titles">
      <Title y={titlesArea.cy} x={centerArea.cx - margin} dy="0.35em" textAnchor="end">
        Costs
      </Title>
      <g style={{ transform: `translate(${centerArea.cx + 80}px, ${titlesArea.cy - imageSize / 2}px)` }}>
        <ArrowRight height={imageSize} width={imageSize} stroke={BouColor.TOOL_TEXT_DARK_GRAY} x={0} y={0} />
      </g>
      <Title y={titlesArea.cy} x={centerArea.cx + margin} dy="0.35em" textAnchor="start">
        Benefits
      </Title>
      <g style={{ transform: `translate(${centerArea.cx - 61 - imageSize}px, ${titlesArea.cy - imageSize / 2}px)` }}>
        <ArrowLeft height={imageSize} width={imageSize} stroke={BouColor.TOOL_TEXT_DARK_GRAY} x={0} y={0} />
      </g>
    </g>
  );
}

const Title = styled.text`
  text-transform: uppercase;
  fill: ${BouColor.TOOL_TEXT_DARK_GRAY};
  letter-spacing: 2px;
`;
